<template>
  <md-table-row class="row-item" :class="{ 'highlight': highlighted }">
    <md-table-cell class="label-cell">
      <div class="cell-content">
        <span class="label-text">{{ label }}<md-icon v-if="icon" class="cell-icon">{{ icon }}</md-icon></span>

      </div>
    </md-table-cell>
    <md-table-cell class="value-cell" :class="valueClass">
      <div class="cell-content">
        <span class="value-text">{{ formattedValue }}</span>
        <md-chip v-if="badge" :class="badgeClass" size="small">{{ badge }}</md-chip>
      </div>
    </md-table-cell>
  </md-table-row>
</template>

<script>
export default {
  name: 'RowItemView',
  props: {
    label: {
      type: String,
      default: 'Label'
    },
    value: {
      type: [String, Number, Boolean, Object],
      default: ''
    },
    valueClass: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: ''
    },
    badge: {
      type: String,
      default: ''
    },
    badgeClass: {
      type: String,
      default: ''
    },
    highlighted: {
      type: Boolean,
      default: false
    },
    format: {
      type: String,
      default: '' // 'currency', 'date', 'phone', 'capitalize'
    }
  },
  computed: {
    formattedValue() {
      if (this.value === undefined || this.value === null || this.value === '') {
        return 'N/A';
      }

      switch (this.format) {
        case 'currency':
          return this.formatCurrency(this.value);
        case 'date':
          return this.formatDate(this.value);
        case 'phone':
          return this.formatPhone(this.value);
        case 'capitalize':
          return this.capitalize(this.value);
        default:
          return this.value;
      }
    }
  },
  methods: {
    formatCurrency(value) {
      return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'TZS',
        minimumFractionDigits: 0
      }).format(value);
    },

    formatDate(value) {
      if (!value) return 'N/A';
      try {
        return new Date(value).toLocaleDateString();
      } catch(e) {
        console.error(e);
        return value;
      }
    },

    formatPhone(value) {
      const phone = String(value);
      if (phone.length === 10) {
        return phone.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      }
      return phone;
    },

    capitalize(value) {
      return String(value).charAt(0).toUpperCase() + String(value).slice(1).toLowerCase();
    }
  }
};
</script>

<style scoped>
.row-item {
  transition: background-color 0.2s ease;
}

.row-item.highlight {
  background-color: #e8f5e9;
}

.label-cell {
  width: 40%;
  background-color: #fafafa;
  font-weight: 500;
  color: #555;
}

.value-cell {
  width: 60%;
}

.cell-content {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  flex-wrap: wrap;
}

.cell-icon {
  font-size: 18px;
  color: #9c27b0;
}

.label-text {
  font-weight: 500;
}

.value-text {
  color: #333;
  word-break: break-word;
}

/* Badge styles */
.md-chip {
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  font-size: 11px;
  border-radius: 16px;
}

/* Responsive */
@media (max-width: 768px) {
  .label-cell {
    width: 35%;
  }

  .value-cell {
    width: 65%;
  }

  .cell-icon {
    font-size: 16px;
  }

  .label-text {
    font-size: 13px;
  }

  .value-text {
    font-size: 13px;
  }
}
</style>